import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/views/About.vue')
  }
  ,
  {
    path: '/category/:outlineId',
    name: 'category',
    props: r => ({ outlineId: r.params.outlineId }),
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "category" */ '@/views/Category.vue')
  }
  ,
  {
    path: '/checkoutfailed',
    name: 'CheckOutFailed',
    //props: r => ({ id: r.params.id }),
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "checkout" */ '@/views/CheckOutFailed.vue')
  }
  ,
  {
    path: '/checkoutsucceeded',
    name: 'CheckoutSucceeded',
    //props: r => ({ id: r.params.id }),
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "checkout" */ '@/views/CheckOutSucceeded.vue')
  }
  ,
  {
    path: '/account',
    name: 'Account',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "checkout" */ '@/views/Account.vue')
  }
  ,
  {
    path: '/helprequest',
    name: 'HelpRequest',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "HelpRequest" */ '@/views/HelpRequest.vue')
  }
  ,
  {
    path: '/submithelprequest/:id',
    name: 'SubmitHelpRequest',
    props: r => ({ id: parseInt( r.params.id) }),
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "HelpRequest" */ '@/views/SubmitHelpRequest.vue')
  },
  {
    path: '/requestreceived',
    name: 'RequestReceived',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "HelpRequest" */ '@/views/RequestReceived.vue')
  },
  {
    path: '/itemdetail/:id',
    name: 'ItemDetail',
    props: r => ({ id: parseInt( r.params.id) } ),
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "ItemDetail" */ '@/views/ItemDetail.vue')
  },
  {
    path: '/ResetPassword',
    name: 'ResetPassword',
    //props: r => ({ id: parseInt( r.params.id) } ),
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "ResetPassword" */ '@/views/ResetPassword.vue')
  },
  {
    path: '/submitprivatehelprequest',
    name: 'SubmitPrivateHelpRequest',
    //props: r => ({ id: r.params.id }),
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "checkout" */ '@/views/SubmitPrivateHelpRequest.vue')
  }
  ,
  {
    path: '/newsubmitprivatehelprequest',
    name: 'NewSubmitPrivateHelpRequest',
    //props: r => ({ id: r.params.id }),
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "checkout" */ '@/views/NewSubmitPrivateHelpRequest.vue')
  }
  ,
  {
    path: '/mydonations',
    name: 'MyDonations',
    //props: r => ({ id: r.params.id }),
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "checkout" */ '@/views/MyDonations.vue')
  }
  ,
  {
    path: '/mysubscriptions',
    name: 'MySubscriptions',
    //props: r => ({ id: r.params.id }),
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "checkout" */ '@/views/MySubscriptions.vue')
  }
  
  ,

  {
    path: '/subscriptiondetail/:id',
    name: 'SubscriptionDetail',
    props: r => ({ id: parseInt( r.params.id) } ),
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "ItemDetail" */ '@/views/SubscriptionDetail.vue')
  },

  
  {
    path: '/donate',
    name: 'Donate',
    //props: r => ({ id: r.params.id }),
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "checkout" */ '@/views/Donate.vue')
  }
  ,
  {
    path: '/test',
    name: 'Test',
    //props: r => ({ id: r.params.id }),
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "checkout" */ '@/views/Test.vue')
  },
  {
    path: '/SubscriptionCheckoutFailed',
    name: 'SubscriptionCheckoutFailed',
    //props: r => ({ id: r.params.id }),
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "checkout" */ '@/views/SubscriptionCheckoutFailed.vue')
  },
  {
    path: '/SubscriptionCheckoutSucceeded',
    name: 'SubscriptionCheckoutSucceeded',
    //props: r => ({ id: r.params.id }),
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "checkout" */ '@/views/SubscriptionCheckoutSucceeded.vue')
  },
  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
